import React, { useState, useEffect, useRef } from 'react';
import './Leads.css';
import Sidebar from './../../components/Sidebar';
import NavBar from './../../components/Navbar';
import { Modal, Button, Form, Spinner, Alert } from 'react-bootstrap';



import { Dropdown, DropdownButton } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaEye } from 'react-icons/fa';

import Userfront from "../../auth/userfrontCompat";

import { usePersistentCollapsedState } from './../../components/SidebarContext'; // Import useSidebar

import { CSVLink } from "react-csv"; // Import CSVLink from react-csv

import api from './../../api/axios'; // Import your axios instance

import { faEllipsisV, faFolder, faCaretDown, faEdit, faUser, faPlus, faTrash, faArchive, faCheckCircle, faReply, faFileCsv, faFileExport, faEye } from '@fortawesome/free-solid-svg-icons';


import Pagination from '../../components/Pagination'; // Import the new Pagination component

import { useTranslation } from 'react-i18next';  // Import useTranslation hook

import { useNotification } from './../../components/NotificationContext';

import AlertComponent from './../../components/Alert'; // Adjust the path as necessary
import { Navigate } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';

import { faLinkedin } from '@fortawesome/free-brands-svg-icons';



export function InlineRename({ initialValue, onSave }) {
  const [val, setVal] = useState(initialValue);
  const [editing, setEditing] = useState(false);

  return editing ? (
    <input
      className="border rounded px-2 py-1 text-sm"
      value={val}
      autoFocus
      onChange={(e) => setVal(e.target.value)}
      onBlur={() => {
        setEditing(false);
        const trimmed = val.trim();
        if (trimmed && trimmed !== initialValue) onSave(trimmed);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') e.currentTarget.blur();
        if (e.key === 'Escape') {
          setVal(initialValue);
          setEditing(false);
        }
      }}
    />
  ) : (
    <span className="cursor-pointer hover:underline" onClick={() => setEditing(true)}>
      {initialValue}
    </span>
  );
}



function Leads() {

  const navigate = useNavigate();

  const location = useLocation();

  const notificationId = useRef(null);


  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const { t, i18n } = useTranslation();  // Initialize translation
  const [userLanguage, setUserLanguage] = useState('en'); // State for user language

  const collapsed = usePersistentCollapsedState();

  const [message, setMessage] = useState(null);

  const [leadLists, setLeadLists] = useState([]);

  const [leads, setLeads] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [selectedLeads, setSelectedLeads] = useState([]); 
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedListFilter, setSelectedListFilter] = useState('all');
  const [recordsPerPage, setRecordsPerPage] = useState(25); // Default records per page


  const { showNotification, removeNotification } = useNotification();
  const [isDeleting, setIsDeleting] = useState(false);

  
  const [currentUser, setCurrentUser] = useState(null);

  const [allLabels, setAllLabels] = useState([]);
  const [selectedLabelFilters, setSelectedLabelFilters] = useState([]);


  const [showLabelDropdown, setShowLabelDropdown] = useState(false);


  const [showModal, setShowModal] = useState(false);
const [newLead, setNewLead] = useState({
  firstName: '',
  lastName: '',
  fullName: '',         // optional; if empty we’ll use first+last
  email: '', 
  organization: '',
  profileUrl: '',
  connected: 'unknown', // ✅ new: 'unknown' | 'yes' | 'no'
});

  const [currentPage, setCurrentPage] = useState(1);

  const [showNewLeadListSalesNavModal, setShowNewLeadListSalesNavModal] = useState(false);
  const [showNewLeadListModal, setShowNewLeadListModal] = useState(false);
  const [showNewLeadListCsvModal, setShowNewLeadListCsvModal] = useState(false);
  const [newLeadList, setNewLeadList] = useState({
    user: Userfront.user.email,
    leadListTitle: '',
    linkedinSearchUrl: '',
    maxQuantity: 10,
  });

  const [leadsFromCsv, setLeadsFromCsv] = useState([]);



  const [showManageLeadListsModal, setShowManageLeadListsModal] = useState(false);
const [showImportPicker, setShowImportPicker] = useState(false);
const [leadListStats, setLeadListStats] = useState([]);
const [addLeadListId, setAddLeadListId] = useState(''); // for Add Lead


const [newListName, setNewListName] = useState('');


const [addLeadListMode, setAddLeadListMode] = useState('existing'); // 'existing' | 'new'
const [newLeadListName, setNewLeadListName] = useState('');


const [newLeadListInline, setNewLeadListInline] = useState('');


const restoredPageRef = useRef(null);
const restoringRef = useRef(false);






// LinkedIn import UI state
const [liImportMode, setLiImportMode] = useState('builder'); // 'builder' | 'url'
const [liKeywords, setLiKeywords] = useState('');
const [liLocation, setLiLocation] = useState('');
const [liCompanies, setLiCompanies] = useState('');

const buildLinkedInPeopleSearchUrl = (keywords) => {
  const base = 'https://www.linkedin.com/search/results/people/?origin=SWITCH_SEARCH_VERTICAL';
  const q = (keywords || '').trim();
  if (!q) return base;
  return `${base}&keywords=${encodeURIComponent(q)}`;
};

const liPreviewUrl = buildLinkedInPeopleSearchUrl(liKeywords);

const liCompaniesArray = (liCompanies || '')
  .split(',')
  .map(s => s.trim())
  .filter(Boolean);



const EllipsisToggle = React.forwardRef(({ onClick }, ref) => (
  <button
    ref={ref}
    type="button"
    className="text-gray-600 p-0 border-0 bg-transparent shadow-none transition-opacity duration-200"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onClick?.(e);
    }}
    aria-label="More options"
  >
    <FontAwesomeIcon icon={faEllipsisV} />
  </button>
));



// Restore filters if we navigated back from LeadDetail
useEffect(() => {
  const from = location.state?.fromFilter;
  if (from) {
    restoringRef.current = true;
    restoredPageRef.current = from.page ?? 1;

    setSelectedListFilter(from.selectedListFilter ?? 'all');
    setSelectedLabelFilters(from.selectedLabelFilters ?? []);
    setSearchTerm(from.searchTerm ?? '');
    setRecordsPerPage(from.recordsPerPage ?? recordsPerPage);

    // Clear state from history so it doesn't re-apply on next nav
    navigate(location.pathname, { replace: true, state: {} });
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [location.state]);



  useEffect(() => {
  let filtered = leads;

  // List filter
  if (selectedListFilter !== 'all') {
    filtered = filtered.filter(lead =>
      lead.leadLists?.some(list => (list.title || list.leadListTitle) === selectedListFilter)
    );
  }

  // Label filters (AND over selection set? Using OR here like before)
  if (selectedLabelFilters.length > 0) {
    filtered = filtered.filter(lead =>
      lead.labels?.some(label => selectedLabelFilters.includes(label))
    );
  }

  // Search (applies after list/labels)
  if (searchTerm?.trim()) {
    const q = searchTerm.trim().toLowerCase();
    filtered = filtered.filter(lead => {
      const name =
        (lead.firstName || '') + ' ' + (lead.lastName || '') ||
        lead.fullName || lead.leadName || '';
      return name.toLowerCase().includes(q);
    });
  }

  setFilteredLeads(filtered);

  // Preserve page only when restoring from LeadDetail
  if (restoringRef.current && restoredPageRef.current != null) {
    setCurrentPage(restoredPageRef.current);
    restoringRef.current = false;
    restoredPageRef.current = null;
  } else {
    setCurrentPage(1);
  }
}, [leads, selectedListFilter, selectedLabelFilters, searchTerm]);



  const fetchLabels = async () => {
    try {
      const user = Userfront.user.email;
      const res = await api.get(`/leads/labels?user=${user}`);
      setAllLabels(res.data);
    } catch (error) {
      console.error('Error fetching labels:', error);
    }
  };

  useEffect(() => {
    fetchLabels();
  }, []);



  const handleCsvUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.error('No file selected.');
      return;
    }
  
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      console.log('CSV Content:', text); // Log the CSV content for debugging
      const json = csvToJson(text);
      console.log('Parsed JSON:', json); // Log the parsed JSON to verify the structure
      setLeadsFromCsv(json);
    };
    reader.readAsText(file);
  };
  
  const fetchUser = async () => {
    try {
      const email = Userfront.user.email;
      const userResponse = await api.get(`/user/user`);
      setCurrentUser(userResponse.data.user);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };


  // CSV can contain: accepted / connected / connection / isConnected / status
  // We normalize to: true | false | null
  const normalizeAcceptedFromCsv = (row) => {
    const raw =
      row.accepted ??
      row.connected ??
      row.connection ??
      row.isConnected ??
      row.connectionStatus ??
      row.status;

    if (raw === undefined || raw === null) return null;

    const v = String(raw).trim().toLowerCase();

    // true values
    if (['1', 'true', 'yes', 'y', 'connected', 'message', '1st', 'first'].includes(v)) return true;

    // false values
    if (['0', 'false', 'no', 'n', 'not connected', 'connect', '2nd', '3rd', 'pending'].includes(v)) return false;

    // allow explicit unknowns
    if (['', 'unknown', 'n/a', 'na', 'null', 'undefined'].includes(v)) return null;

    // fallback: null (so we can auto-check later if needed)
    return null;
  };

  

  const pickFirst = (obj, keys) => {
  for (const k of keys) {
    if (obj[k] !== undefined && obj[k] !== null && String(obj[k]).trim() !== '') {
      return String(obj[k]).trim();
    }
  }
  return null;
};

const normalizeEmailFromCsv = (row) => {
  const email = pickFirst(row, [
    'email',
    'Email',
    'E-mail',
    'e-mail',
    'mail',
    'Mail',
    'workEmail',
    'WorkEmail',
    'work_email',
    'emailAddress',
    'EmailAddress',
    'email_address',
  ]);

  if (!email) return null;

  // very light validation: keep it permissive
  const v = email.trim();
  if (!v.includes('@')) return null;
  return v;
};


  const csvToJson = (csv) => {
    const lines = csv.trim().split('\n');

    const delimiter = lines[0].includes(';') ? ';' : ',';
    const headers = lines[0].split(delimiter).map((h) => h.trim());

    const result = [];

    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;

      const currentline = line.split(delimiter).map((field) => field.trim());

      if (currentline.length === headers.length) {
        const obj = {};
        for (let j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j];
        }

        // ✅ Normalize accepted status from CSV
        obj.accepted = normalizeAcceptedFromCsv(obj);

        // ✅ Normalize email
        obj.email = normalizeEmailFromCsv(obj);


        // (optional) also normalize profileUrl whitespace
        if (obj.profileUrl) obj.profileUrl = obj.profileUrl.trim();

        result.push(obj);
      } else {
        console.warn(`Skipping invalid line: ${line}`);
      }
    }

    console.log('Parsed JSON:', result);
    return result;
  };

  
  

  
  // Handle individual checkbox change
  const handleCheckboxChange = (leadId) => {
    setSelectedLeads((prevSelected) =>
      prevSelected.includes(leadId)
        ? prevSelected.filter((id) => id !== leadId)
        : [...prevSelected, leadId]
    );
  };

  // Handle "Select All" checkbox change
  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setSelectedLeads(filteredLeads.map((lead) => lead._id));
    } else {
      setSelectedLeads([]);
    }
  };

  // Delete selected leads
  const handleDeleteSelected = async () => {
    if (selectedLeads.length === 0) {
      const id = showNotification(t('leads.noLeadsSelected'), 'warning');
      setTimeout(() => removeNotification(id), 4000);
      return;
    }
  
    setIsDeleting(true); // Start button spinner
    try {
      const response = await api.delete('/leads/delete', {
        data: { leadIds: selectedLeads },
      });
  
      if (response.status === 200) {
        const updatedLeads = leads.filter((lead) => !selectedLeads.includes(lead._id));
        setLeads(updatedLeads);
        setFilteredLeads(updatedLeads);
        setSelectedLeads([]);
        setSelectedListFilter('all'); // Reset filter
  
        fetchLeadLists();
        fetchLeads();
  
        const id = showNotification(t('leads.deletedSuccessfully'), 'success');
        setTimeout(() => removeNotification(id), 4000);
  
        // Optional: simulate brief delay for better UX
        await new Promise((resolve) => setTimeout(resolve, 700)); 
      } else {
        const id = showNotification(t('leads.deletionFailed'), 'danger');
        setTimeout(() => removeNotification(id), 4000);
      }
    } catch (error) {
      console.error('Error deleting leads:', error);
      const id = showNotification(t('leads.deletionError'), 'danger');
      setTimeout(() => removeNotification(id), 4000);
    } finally {
      setIsDeleting(false);
    }
  };
  
  
  
  



 const handleManageClick = (leadId) => {
  navigate(`/leads/${leadId}`, {
    state: {
      fromFilter: {
        selectedListFilter,
        selectedLabelFilters,   // ⟵ add
        searchTerm,
        page: currentPage,
        recordsPerPage,         // ⟵ add
      },
    },
  });
};



  // Calculate the index of the last lead on the current page
  const indexOfLastLead = currentPage * recordsPerPage;
  // Calculate the index of the first lead on the current page
  const indexOfFirstLead = indexOfLastLead - recordsPerPage;
  // Get the leads for the current page
  const currentLeads = filteredLeads.slice(indexOfFirstLead, indexOfLastLead);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);

    // Scroll to the top of the leads list
    const leadsListElement = document.querySelector('.leads-header-row') || document.querySelector('.lead-card');
    if (leadsListElement) {
      leadsListElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

  };

  const handleRecordsPerPageChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to the first page when changing records per page
  };

  


 



  // Map label name -> color from allLabels (fallback gray)
const getLabelColor = (allLabels, name) =>
  allLabels.find((l) => l.name === name)?.color || '#6B7280'; // Tailwind gray-500

const LabelPill = ({ name, color, title }) => (
  <span
    className="inline-flex items-center gap-1 rounded-full text-[11px] px-2 py-1 font-medium text-white"
    style={{ backgroundColor: color }}
    title={title || name}
  >
    <span
      className="inline-block w-2 h-2 rounded-full"
      style={{ backgroundColor: 'rgba(255,255,255,0.9)' }}
    />
    {name}
  </span>
);

const ListPill = ({ name, title }) => (
  <span
    className="inline-flex items-center gap-1 rounded-full text-[11px] px-2 py-1 font-medium border border-blue-200 text-blue-800 bg-blue-50"
    title={title || name}
  >
    <FontAwesomeIcon icon={faFolder} className="opacity-80" />
    {name}
  </span>
);




  const handleNewLeadSubmit = async () => {
  try {
    const user = Userfront.user.email;

    // Create list first if user typed a new list name
    let chosen = leadLists.find(l => String(l._id) === String(addLeadListId));
    if (!chosen && newListName.trim()) {
      const r = await api.post('/leads/lead-lists', {
        user,
        leadListTitle: newListName.trim(),
      });
      chosen = r.data; // { _id, leadListTitle, ... }
    }

    const fn = (newLead.firstName || '').trim();
    const ln = (newLead.lastName || '').trim();
    const full = (newLead.fullName || `${fn} ${ln}`).trim();

    if (!full) {
      const id = showNotification('Please enter a name (first + last, or full name).', 'danger');
      setTimeout(() => removeNotification(id), 3000);
      return;
    }

    await api.post('/leads/single', {
      user,
      firstName: fn || null,
      lastName: ln || null,
      fullName: full,
      leadName: full, // legacy for compatibility
      email: (newLead.email || '').trim() || null,
      organization: newLead.organization?.trim() || null,
      profileUrl: newLead.profileUrl?.trim() || null,
      leadListId: chosen?._id || null,
      leadListTitle: chosen?.leadListTitle || null,
      connected: newLead.connected === 'unknown' ? null : newLead.connected,
    });

    setShowModal(false);
    setNewLead({ firstName: '', lastName: '', fullName: '', email: '', organization: '', profileUrl: '', connected: 'unknown' });
    setAddLeadListId('');
    setNewListName('');
    await fetchLeads();
    await fetchLeadLists();
    await fetchLeadListStats();
    const id = showNotification('Lead added', 'success'); setTimeout(() => removeNotification(id), 2500);
  } catch (error) {
    console.error('Error creating new lead:', error?.response?.data || error);
    const id = showNotification(error?.response?.data?.error || 'Failed to add lead', 'danger');
    setTimeout(() => removeNotification(id), 3000);
  }
};






  // Fetch lead lists for the current user

    const fetchLeadLists = async () => {
      try {
        // Fetch the current user data from Userfront
        const user = await Userfront.user.email;

        // Make an API request to fetch lead lists for the user
        const response = await api.get(`/leads/lead-lists?user=${user}`);

        // Update the lead lists state with the data from the backend
        setLeadLists(response.data);
      } catch (error) {
        console.error('Error fetching lead lists:', error.response.data);
      }
    };


    // Fetch user language setting from the database
  const fetchUserLanguage = async () => {
    try {
      const response = await api.get(`/user/user`);
      setUserLanguage(response.data.language);
      i18n.changeLanguage(response.data.language); // Set language in i18next
    } catch (error) {
      console.error('Error fetching user settings:', error);
    }
  };

  useEffect(() => {
    fetchUser();
    fetchLeadLists();
    fetchUserLanguage();
  }, []);

  const handleNewLeadListSubmit = async () => {
    setIsLoading(true);
    setErrorMessage('');

    const notificationId = showNotification('Importing leads', 'info', true);
    setShowNewLeadListModal(false);

    try {
      const payload = {
        user: Userfront.user.email,
        leadListTitle: newLeadList.leadListTitle,
        maxQuantity: newLeadList.maxQuantity,
        proxyServer: currentUser.proxyServer,
      };

      if (liImportMode === 'url') {
        // Advanced: user pasted the full LinkedIn URL
        payload.linkedinSearchUrl = newLeadList.linkedinSearchUrl?.trim();
      } else {
        // Guided: user entered keywords + optional filters
        payload.linkedinSearch = {
          keywords: liKeywords.trim(),
          location: liLocation.trim() || null,
          companies: liCompaniesArray, // optional
          // You can extend this later with seniority, degree, etc.
        };

        // We still send a URL to start on a predictable page
        payload.linkedinSearchUrl = buildLinkedInPeopleSearchUrl(liKeywords);
      }

      // Basic validation
      if (!payload.leadListTitle?.trim()) throw new Error('Please enter a lead list name.');
      if (liImportMode === 'builder' && !liKeywords.trim()) throw new Error('Please enter at least one keyword.');
      if (liImportMode === 'url' && !payload.linkedinSearchUrl) throw new Error('Please paste a LinkedIn people search URL.');

      await api.post('/leads/linkedin', payload);

      removeNotification(notificationId);
      const successId = showNotification('Leads extracted successfully!', 'success');
      setTimeout(() => removeNotification(successId), 5000);

      fetchLeadLists();
      fetchLeads();
      setSelectedListFilter('all');
      setCurrentPage(1);
    } catch (error) {
      console.error('Error importing leads:', error?.response?.data || error);
      removeNotification(notificationId);
      const msg = error?.response?.data?.error || error?.message || 'Error extracting leads.';
      const errorId = showNotification(msg, 'danger');
      setTimeout(() => removeNotification(errorId), 5000);
    } finally {
      setIsLoading(false);
    }
  };


  




const fetchLeadListStats = async () => {
  try {
    const user = Userfront.user.email;
    const res = await api.get(`/leads/lead-lists/stats?user=${user}`);
    setLeadListStats(res.data || []);
  } catch (e) {
    console.error('Error fetching lead list stats:', e);
  }
};

// wherever you call fetchLeadLists(); also call:
useEffect(() => {
  fetchLeadLists();
  fetchLeadListStats();
  fetchLeads();
  fetchUserLanguage();
  fetchUser();
}, []);

  
  


  

  const handleNewLeadListSubmitCsv = async () => {
  try {
    const invalidLeads = leadsFromCsv.filter((lead) => {
      if (!lead.profileUrl) return false; // ✅ allow empty
      return (
        !lead.profileUrl.startsWith('https://www.linkedin.com/in/') ||
        /\s/.test(lead.profileUrl)
      );
    });


    if (invalidLeads.length > 0) {
      setErrorMessage('Some leads have invalid LinkedIn profile URLs.');
      setSuccessMessage('');
      return;
    }

    setIsLoading(true);
    const notificationId = showNotification('Uploading leads from CSV...', 'info', true);
    setShowNewLeadListCsvModal(false); // Close after spinner

    const response = await api.post('/leads/csv', {
      user: Userfront.user.email,
      leadListTitle: newLeadList.leadListTitle,
      maxQuantity: newLeadList.maxQuantity,
      leads: leadsFromCsv,
    });

    removeNotification(notificationId);

    const successId = showNotification('CSV leads uploaded successfully!', 'success');
    setTimeout(() => removeNotification(successId), 5000);

    fetchLeadLists();
    fetchLeads();
    setSelectedListFilter('all');
    setCurrentPage(1);

  } catch (error) {
    console.error('Error creating lead list from CSV:', error.response?.data || error);
    removeNotification(notificationId);
    const errorId = showNotification('Error creating lead list from CSV.', 'danger');
    setTimeout(() => removeNotification(errorId), 5000);
  } finally {
    setIsLoading(false);
  }
};

  



  const handleNewLeadListSubmitSalesNav = async () => {
  setIsLoading(true);
  setErrorMessage('');

  const notificationId = showNotification('Importing leads from Sales Navigator...', 'info', true);
  setShowNewLeadListSalesNavModal(false); // Close after spinner

  try {
    const response = await api.post('/leads/salesnavigator', {
      user: Userfront.user.email,
      leadListTitle: newLeadList.leadListTitle,
      salesNavUrl: newLeadList.linkedinSearchUrl,
      maxQuantity: newLeadList.maxQuantity,
      proxyServer: currentUser.proxyServer,
    });

    removeNotification(notificationId);

    const successId = showNotification('Sales Navigator leads extracted!', 'success');
    setTimeout(() => removeNotification(successId), 5000);

    fetchLeadLists();
    fetchLeads();
    setSelectedListFilter('all');
    setCurrentPage(1);

  } catch (error) {
    console.error('Error importing from Sales Navigator:', error.response?.data || error);
    removeNotification(notificationId);
    const errorId = showNotification('Failed to import from Sales Navigator.', 'danger');
    setTimeout(() => removeNotification(errorId), 5000);
  } finally {
    setIsLoading(false);
  }
};


  



  // Fetch leads for the current user
    const fetchLeads = async () => {
      try {
        // Fetch the current user data from Userfront
        const user = Userfront.user.email;

        // Make an API request to fetch leads for the user
        const response = await api.get(`/leads/leads?user=${user}`);

        // Update the leads state with the data from the backend
        setLeads(response.data);
        setFilteredLeads(response.data); // Initialize filteredLeads with all leads
      } catch (error) {
        console.error('Error fetching leads:', error.response.data);
      }
    };


  useEffect(() => {
    fetchLeads();
  }, []);



  // Function to export leads data to CSV
  const exportLeadsToCSV = () => {
    const csvData = filteredLeads.map((lead) => ({
      id: lead._id,
      leadName: lead.leadName,
      profileUrl: lead.profileUrl,
      leadList: lead.leadListTitle,
    }));

    return csvData;
  };



  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);


  

  // This is the updated Tailwind-based return block for the Leads component
return (
 <div className="border-t border-gray-200">
  <div className="min-h-screen bg-gray-50 transition-all space-y-6 px-2 pt-2 sm:px-3 md:px-4 xl:px-8 mb-6">
    <div className="space-y-6 px-2 sm:px-3 md:px-4 lg:px-6 pt-2">

      {/* Header + Controls */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h2 className="text-2xl font-semibold text-gray-800 flex items-center gap-3">
            {t('leads.title')}
            <span className="text-sm text-gray-500 font-normal">
              (
              {selectedListFilter === 'all'
                ? `${filteredLeads.length} ${t('leads.leads')}`
                : `${t('leads.showing')} ${filteredLeads.length} ${t('leads.of')} ${leads.length} ${t('leads.leads')}`}
              )
            </span>
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row gap-2 sm:items-center">
          <input
            type="text"
            placeholder={t('leads.searchPlaceholder')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm w-full sm:w-auto h-10"
          />

          <select
            value={selectedListFilter}
            onChange={(e) => setSelectedListFilter(e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm bg-white w-full sm:w-auto h-10"
          >
            <option value="all">{t('leads.selectLeadList')}</option>
            {leadLists.map((leadList) => (
              <option key={leadList._id} value={leadList.leadListTitle}>
                {leadList.leadListTitle}
              </option>
            ))}
          </select>


          <div className="relative">
            <button
              className="border border-gray-300 rounded-md px-3 py-2 text-sm bg-white w-full sm:w-auto h-10 flex items-center justify-between gap-2"
              onClick={() => setShowLabelDropdown(prev => !prev)}
            >
              {selectedLabelFilters.length > 0
                ? `${selectedLabelFilters.length} ${t('leads.labelsSelected')}`
                : t('leads.selectLabels')}
              <FontAwesomeIcon icon={faCaretDown} />
            </button>
            {showLabelDropdown && (
              <div className="absolute z-10 bg-white border border-gray-200 rounded-md shadow-md mt-1 p-2 w-64 max-h-60 overflow-y-auto">
                {allLabels.map((label) => (
                  <label key={label._id} className="flex items-center gap-2 cursor-pointer py-1 px-2 hover:bg-gray-100 rounded">
                    <input
                      type="checkbox"
                      checked={selectedLabelFilters.includes(label.name)}
                      onChange={() => {
                        setSelectedLabelFilters((prev) =>
                          prev.includes(label.name)
                            ? prev.filter((l) => l !== label.name)
                            : [...prev, label.name]
                        );
                      }}
                    />
                    <span className="text-sm">{label.name}</span>
                  </label>
                ))}
              </div>
            )}
          </div>



          <Dropdown align="end">
            <Dropdown.Toggle
              as="button"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm shadow-sm h-10"
            >
              {t('leads.manageLeads')}
            </Dropdown.Toggle>
            <Dropdown.Menu className="text-sm">
              <Dropdown.Item onClick={() => setShowModal(true)}>
                <FontAwesomeIcon icon={faPlus} className="text-blue-600 mr-2" />
                Add lead
              </Dropdown.Item>

              <Dropdown.Item onClick={() => setShowImportPicker(true)}>
                <FontAwesomeIcon icon={faFileCsv} className="text-green-600 mr-2" />
                Import leads
              </Dropdown.Item>

              <Dropdown.Item onClick={() => setShowManageLeadListsModal(true)}>
                <FontAwesomeIcon icon={faEdit} className="text-blue-600 mr-2" />
                Manage lead lists
              </Dropdown.Item>

              <Dropdown.Item as="div">
                <CSVLink
                  data={exportLeadsToCSV()}
                  filename="leads.csv"
                  className="text-blue-600 hover:underline flex items-center px-3 py-2"
                >
                  <FontAwesomeIcon icon={faFileExport} className="text-blue-600 mr-2" />
                  Export
                </CSVLink>
              </Dropdown.Item>
            </Dropdown.Menu>

          </Dropdown>
        </div>
      </div>

      {/* Delete Button */}
      {selectedLeads.length > 0 && (
        <div>
          <button
            onClick={handleDeleteSelected}
            disabled={isDeleting}
            className="bg-red-600 text-white px-4 py-2 rounded-md text-sm shadow-sm w-full sm:w-auto flex items-center justify-center"
          >
            {isDeleting ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                {t('leads.deleting')}
              </>
            ) : t('leads.deleteSelection')}
          </button>
        </div>
      )}

      {/* Lead Cards */}
      <div>
        {filteredLeads.length === 0 ? (
          <div className="flex flex-col items-center text-center space-y-4">
            <img src="/images/leads.png" className="w-32" alt="Empty inbox" />
            <p className="text-gray-600">Start with importing your leads.</p>
            <div className="flex flex-wrap justify-center gap-3">
              <button onClick={() => setShowNewLeadListModal(true)} className="border border-blue-600 text-blue-600 px-4 py-2 rounded-md text-sm hover:bg-blue-50">
                <FontAwesomeIcon icon={faUser} className="mr-2" /> {t('leads.importFromSalesNavigator')}
              </button>
              <button onClick={() => setShowNewLeadListSalesNavModal(true)} className="border border-blue-600 text-blue-600 px-4 py-2 rounded-md text-sm hover:bg-blue-50">
                <FontAwesomeIcon icon={faUser} className="mr-2" /> {t('leads.importFromLinkedIn')}
              </button>
              <button onClick={() => setShowNewLeadListCsvModal(true)} className="border border-green-600 text-green-600 px-4 py-2 rounded-md text-sm hover:bg-green-50">
                <FontAwesomeIcon icon={faFileCsv} className="mr-2" /> {t('leads.importFromCSV')}
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-1">
            {currentLeads.map((lead) => (


              <div
  key={lead._id}
  onDoubleClick={() => handleManageClick(lead._id)}
  className="bg-white border rounded-xl shadow-sm px-3 py-2 md:px-3 md:py-2 cursor-pointer hover:shadow transition-shadow"
>
  {/* ROW 1: checkbox + avatar + name + LI + status | lead lists (right) | menu */}
  <div className="flex items-center gap-3">
    {/* Select */}
    <input
      type="checkbox"
      checked={selectedLeads.includes(lead._id)}
      onChange={() => handleCheckboxChange(lead._id)}
      aria-label="Select lead"
      className="shrink-0"
    />

    {/* Avatar */}
    <div className="w-10 h-10 rounded overflow-hidden bg-gray-100 shrink-0">
      {lead.profileImageUrl ? (
        <img src={lead.profileImageUrl} alt={t('leads.avatar')} className="w-10 h-10 object-cover" />
      ) : (
        <div className="w-10 h-10 grid place-items-center text-gray-400 text-xs">—</div>
      )}
    </div>

    {/* Name + LinkedIn + status */}
    <div className="min-w-0 flex-1">
      <div className="flex items-center gap-2 min-w-0">
        <div className="font-medium text-sm md:text-[15px] truncate">
          {(lead.firstName || lead.lastName)
            ? `${lead.firstName ?? ''} ${lead.lastName ?? ''}`.trim()
            : (lead.fullName || lead.leadName || '—')}
        </div>
        {lead.profileUrl && (
          <a
            href={lead.profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            title={lead.profileUrl}
            onClick={(e) => e.stopPropagation()}
            className="text-blue-600 hover:text-blue-700 shrink-0"
            aria-label="Open LinkedIn profile"
          >
            <FontAwesomeIcon icon={faLinkedin} className="text-[16px]" />
          </a>
        )}

        {/* Connected / Not connected / Unknown right of LinkedIn */}
        {lead.accepted === true ? (
          <span
            className="inline-flex items-center text-green-700 bg-green-100 text-[11px] font-medium px-2 py-[2px] rounded-full shrink-0"
            title={t('leads.connected') || 'Connected'}
          >
            ✓ {t('leads.connected') || 'Connected'}
          </span>
        ) : lead.accepted === false ? (
          <span
            className="inline-flex items-center text-red-700 bg-red-100 text-[11px] font-medium px-2 py-[2px] rounded-full shrink-0"
            title={t('leads.notConnected') || 'Not connected'}
          >
            ✕ {t('leads.notConnected') || 'Not connected'}
          </span>
        ) : (
          <span
            className="inline-flex items-center text-gray-700 bg-gray-100 text-[11px] font-medium px-2 py-[2px] rounded-full shrink-0"
            title={t('leads.connectionUnknown') || 'Connection unknown'}
          >
            ? {t('leads.connectionUnknown') || 'Unknown'}
          </span>
        )}


      </div>

      {/* Optional org under name (still compact) */}
      {lead.organization && (
        <div className="text-[11px] text-gray-500 leading-tight truncate mt-0.5">{lead.organization}</div>
      )}
    </div>

    {/* Lead lists on the RIGHT */}
    <div className="hidden md:flex items-center gap-1.5 flex-wrap justify-end max-w-[40%]">
      {(lead.leadLists || []).slice(0, 3).map((list, idx) => (
        <ListPill key={idx} name={list.title || list.leadListTitle} />
      ))}
      {lead.leadLists && lead.leadLists.length > 3 && (
        <span
          className="inline-flex items-center rounded-full text-[11px] px-2 py-[2px] font-medium bg-gray-100 text-gray-800 border border-gray-200"
          title={lead.leadLists.slice(3).map(l => l.title || l.leadListTitle).join(', ')}
        >
          +{lead.leadLists.length - 3}
        </span>
      )}
    </div>

    {/* Menu */}
    <Dropdown align="end">
      <Dropdown.Toggle as={EllipsisToggle} />
      <Dropdown.Menu className="text-sm">
        <Dropdown.Item onClick={() => handleManageClick(lead._id)}>
          <FontAwesomeIcon icon={faEye} className="me-2" /> {t('leads.table.view')}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  </div>

  {/* ROW 2: labels (only if any) */}
  {Array.isArray(lead.labels) && lead.labels.length > 0 && (
    <div className="flex flex-wrap items-center gap-1.5 mt-2 pl-[2.75rem] md:pl-[3.25rem]">
      {lead.labels.slice(0, 5).map((label, idx) => (
        <LabelPill key={idx} name={label} color={getLabelColor(allLabels, label)} />
      ))}
      {lead.labels.length > 5 && (
        <span
          className="inline-flex items-center rounded-full text-[11px] px-2 py-[2px] font-medium bg-gray-200 text-gray-800"
          title={lead.labels.slice(5).join(', ')}
        >
          +{lead.labels.length - 5}
        </span>
      )}
    </div>
  )}

  {/* On small screens, show lead lists below as a short row */}
  {lead.leadLists?.length > 0 && (
    <div className="md:hidden flex flex-wrap items-center gap-1.5 mt-2 pl-[2.75rem]">
      {(lead.leadLists || []).slice(0, 3).map((list, idx) => (
        <ListPill key={idx} name={list.title || list.leadListTitle} />
      ))}
      {lead.leadLists.length > 3 && (
        <span
          className="inline-flex items-center rounded-full text-[11px] px-2 py-[2px] font-medium bg-gray-100 text-gray-800 border border-gray-200"
          title={lead.leadLists.slice(3).map(l => l.title || l.leadListTitle).join(', ')}
        >
          +{lead.leadLists.length - 3}
        </span>
      )}
    </div>
  )}
</div>









            ))}
          </div>
        )}
      </div>

      {filteredLeads.length > 0 && (
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 border-t pt-4">
          <div className="flex items-center gap-2 min-w-[140px]">
          <span className="text-sm text-gray-600 whitespace-nowrap">
            {t('pagination.rowsPerPage')}
          </span>
          <select
            value={recordsPerPage}
            onChange={(e) => setRecordsPerPage(Number(e.target.value))}
            className="border border-gray-300 rounded-md px-2 py-1 text-sm bg-white"
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>


          <Pagination
            currentPage={currentPage}
            totalItems={filteredLeads.length}
            recordsPerPage={recordsPerPage}
            paginate={paginate}
          />
        </div>
      )}



    </div>
  </div>






{showImportPicker && (
  <div className="fixed inset-0 bg-white/40 backdrop-blur-sm flex items-center justify-center z-50">
    <div className="bg-white w-full max-w-md p-6 rounded-xl shadow-xl border">
      <h3 className="text-lg font-semibold mb-3">Import leads</h3>
      <div className="grid gap-3">
        <button onClick={() => { setShowImportPicker(false); setShowNewLeadListModal(true); }} className="border px-4 py-2 rounded">
          From LinkedIn search
        </button>
        <button onClick={() => { setShowImportPicker(false); setShowNewLeadListSalesNavModal(true); }} className="border px-4 py-2 rounded">
          From Sales Navigator
        </button>
        <button onClick={() => { setShowImportPicker(false); setShowNewLeadListCsvModal(true); }} className="border px-4 py-2 rounded">
          From CSV
        </button>
      </div>
      <div className="flex justify-end mt-4">
        <button className="px-4 py-2 rounded bg-gray-100" onClick={() => setShowImportPicker(false)}>Close</button>
      </div>
    </div>
  </div>
)}





{showManageLeadListsModal && (
  <div className="fixed inset-0 bg-white/40 backdrop-blur-sm flex items-center justify-center z-50">
    <div className="bg-white w-full max-w-lg p-6 rounded-xl shadow-xl border">
      <h3 className="text-lg font-semibold mb-4">Manage lead lists</h3>

      {/* Create */}
      <div className="flex gap-2 mb-4">
        <input
          id="newLeadListInput"
          type="text"
          placeholder="New list name"
          className="border rounded px-3 py-2 text-sm flex-1"
          value={newLeadListInline}
          onChange={(e)=>setNewLeadListInline(e.target.value)}
          onKeyDown={async (e) => {
            if (e.key === 'Enter') {
              const title = newLeadListInline.trim();
              if (!title) return;
              try {
                await api.post('/leads/lead-lists', { user: Userfront.user.email, leadListTitle: title });
                setNewLeadListInline('');
                await fetchLeadLists();
                await fetchLeadListStats();
                const id = showNotification('Lead list created', 'success'); setTimeout(()=>removeNotification(id), 2500);
              } catch {
                const id = showNotification('Failed to create list', 'danger'); setTimeout(()=>removeNotification(id), 3000);
              }
            }
          }}
        />
        <button
          className="bg-blue-600 text-white px-3 rounded"
          onClick={async () => {
            const title = newLeadListInline.trim();
            if (!title) return;
            try {
              await api.post('/leads/lead-lists', { user: Userfront.user.email, leadListTitle: title });
              setNewLeadListInline('');
              await fetchLeadLists();
              await fetchLeadListStats();
              const id = showNotification('Lead list created', 'success'); setTimeout(()=>removeNotification(id), 2500);
            } catch {
              const id = showNotification('Failed to create list', 'danger'); setTimeout(()=>removeNotification(id), 3000);
            }
          }}
        >
          Create
        </button>
      </div>



      {/* List table */}
      <div className="max-h-80 overflow-auto border rounded">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left px-3 py-2">Name</th>
              <th className="text-left px-3 py-2 w-24">Leads</th>
              <th className="px-3 py-2 w-40">Actions</th>
            </tr>
          </thead>
          <tbody>
            {leadListStats.map((l) => (
              <tr key={l._id} className="border-t">
                <td className="px-3 py-2">
                  <InlineRename
                    initialValue={l.leadListTitle}
                    onSave={async (val) => {
                      try {
                        await api.patch(`/leads/lead-lists/${l._id}`, {
                          user: Userfront.user.email,
                          leadListTitle: val
                        });
                        await fetchLeadLists();
                        await fetchLeadListStats();
                        const id = showNotification('List renamed', 'success'); setTimeout(()=>removeNotification(id), 2000);
                      } catch {
                        const id = showNotification('Rename failed', 'danger'); setTimeout(()=>removeNotification(id), 2500);
                      }
                    }}
                  />
                </td>
                <td className="px-3 py-2">{l.count}</td>
                <td className="px-3 py-2">
                  <button
                    className="text-red-600 border border-red-600 px-3 py-1 rounded"
                    onClick={async () => {
                      if (!window.confirm(`Delete "${l.leadListTitle}"?\n\nThis will remove the list from its leads. Leads that don't belong to any other list will also be deleted.`)) return;
                      try {
                        await api.delete(`/leads/lead-lists/${l._id}`, { params: { user: Userfront.user.email } });
                        await fetchLeadLists();
                        await fetchLeadListStats();
                        await fetchLeads();
                        const id = showNotification('List deleted', 'success'); setTimeout(()=>removeNotification(id), 2500);
                      } catch {
                        const id = showNotification('Delete failed', 'danger'); setTimeout(()=>removeNotification(id), 2500);
                      }
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {leadListStats.length === 0 && (
              <tr><td colSpan="3" className="px-3 py-6 text-center text-gray-500">No lists yet</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="flex justify-end mt-4">
        <button className="px-4 py-2 rounded bg-gray-100" onClick={() => setShowManageLeadListsModal(false)}>Close</button>
      </div>
    </div>
  </div>
)}




    
      {/* Modal for adding a new lead (first/last/full + inline list create) */}
      {showModal && (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md p-6 rounded-xl shadow-xl border">
            <h3 className="text-lg font-semibold">Add lead</h3>

            <div className="space-y-4 mt-4">
              {/* Name group */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm font-medium">First name</label>
                  <input
                    type="text"
                    className="mt-1 w-full border rounded px-3 py-2 text-sm"
                    value={newLead.firstName}
                    onChange={(e) => setNewLead(s => ({ ...s, firstName: e.target.value }))}
                    placeholder="Jane"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium">Last name</label>
                  <input
                    type="text"
                    className="mt-1 w-full border rounded px-3 py-2 text-sm"
                    value={newLead.lastName}
                    onChange={(e) => setNewLead(s => ({ ...s, lastName: e.target.value }))}
                    placeholder="Doe"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium">
                  Full name <span className="text-gray-400 font-normal">(optional)</span>
                </label>
                <input
                  type="text"
                  className="mt-1 w-full border rounded px-3 py-2 text-sm"
                  value={newLead.fullName}
                  onChange={(e) => setNewLead(s => ({ ...s, fullName: e.target.value }))}
                  placeholder="If empty we’ll use First + Last"
                />
                {/* small helper hint */}
                {(newLead.firstName || newLead.lastName) && !newLead.fullName && (
                  <p className="text-xs text-gray-500 mt-1">
                    Will save as: <span className="font-medium">
                      {`${(newLead.firstName || '').trim()} ${(newLead.lastName || '').trim()}`.trim() || '—'}
                    </span>
                  </p>
                )}
              </div>


              <div>
                <label className="block text-sm font-medium">Email <span className="text-gray-400 font-normal">(optional)</span></label>
                <input
                  type="email"
                  className="mt-1 w-full border rounded px-3 py-2 text-sm"
                  value={newLead.email}
                  onChange={(e) => setNewLead(s => ({ ...s, email: e.target.value }))}
                  placeholder="jane@company.com"
                />
              </div>

              {/* Optional fields */}
              <div>
                <label className="block text-sm font-medium">LinkedIn profile URL</label>
                <input
                  type="url"
                  className="mt-1 w-full border rounded px-3 py-2 text-sm"
                  value={newLead.profileUrl}
                  onChange={(e) => setNewLead(s => ({ ...s, profileUrl: e.target.value }))}
                  placeholder="https://www.linkedin.com/in/username"
                />
              </div>

              <div>
                <label className="block text-sm font-medium">
                  LinkedIn connection <span className="text-gray-400 font-normal">(optional)</span>
                </label>

                <select
                  className="mt-1 w-full border rounded px-3 py-2 text-sm bg-white"
                  value={newLead.connected}
                  onChange={(e) => setNewLead(s => ({ ...s, connected: e.target.value }))}
                >
                  <option value="unknown">Unknown (auto-check later)</option>
                  <option value="yes">Yes (already connected)</option>
                  <option value="no">No (not connected)</option>
                </select>

                <p className="text-xs text-gray-500 mt-1">
                  If you choose “Unknown”, the workflow can check it automatically later.
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium">Organization</label>
                <input
                  type="text"
                  className="mt-1 w-full border rounded px-3 py-2 text-sm"
                  value={newLead.organization}
                  onChange={(e) => setNewLead(s => ({ ...s, organization: e.target.value }))}
                  placeholder="Company (optional)"
                />
              </div>

              {/* List selection / inline create */}
              <div>
                <label className="block text-sm font-medium">Lead list</label>
                <select
                  className="mt-1 w-full border rounded px-3 py-2 text-sm"
                  value={addLeadListId || (newListName ? '__new__' : '')}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (v === '__new__') {
                      setAddLeadListId('');
                      // keep whatever user typed in newListName
                    } else {
                      setAddLeadListId(v);
                      setNewListName(''); // clear inline new name when choosing existing
                    }
                  }}
                >
                  <option value="">(none)</option>
                  {leadLists.map((l) => (
                    <option key={l._id} value={l._id}>
                      {l.leadListTitle}
                    </option>
                  ))}
                  <option value="__new__">+ Create new list…</option>
                </select>

                {/* Inline new list name */}
                {(addLeadListId === '' && newListName !== '') || (addLeadListId === '' && !leadLists.length) || (addLeadListId === '' && document.activeElement?.value === '__new__') ? null : null}
                {(!addLeadListId && (
                  <>
                    {/*
                      Show the text input when:
                      - user chose "+ Create new list…" OR
                      - there are no lists yet and they want to type one
                    */}
                    {(newListName !== '' || !leadLists.length) && (
                      <input
                        type="text"
                        className="mt-2 w-full border rounded px-3 py-2 text-sm"
                        placeholder="New list name"
                        value={newListName}
                        onChange={(e) => setNewListName(e.target.value)}
                      />
                    )}
                  </>
                ))}
              </div>
            </div>

            {/* Actions */}
            <div className="flex justify-end gap-2 mt-6">
              <button
                onClick={() => {
                  setShowModal(false);
                  setNewLead({ firstName: '', lastName: '', fullName: '', email: '', organization: '', profileUrl: '', connected: 'unknown' });
                  setAddLeadListId('');
                  setNewListName('');
                }}
                className="bg-gray-100 text-gray-800 px-4 py-2 rounded-md text-sm"
              >
                Close
              </button>
              <button
                onClick={handleNewLeadSubmit}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm"
              >
                Create lead
              </button>
            </div>
          </div>
        </div>
      )}


  
      {showNewLeadListModal && (
        <div className="fixed inset-0 bg-white/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-gray-100 w-full max-w-lg p-6 rounded-xl shadow-xl border">
            <div className="flex items-start justify-between gap-3">
              <div>
                <h3 className="text-lg font-semibold">Import from LinkedIn search</h3>
                <p className="text-sm text-gray-600 mt-1">
                  Use keywords (and optional filters). Advanced users can paste a full LinkedIn search URL.
                </p>
              </div>
              <button
                className="text-gray-500 hover:text-gray-700 text-xl leading-none"
                onClick={() => setShowNewLeadListModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            {/* Lead list name + quantity */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-5">
              <div className="sm:col-span-2">
                <label className="block text-sm font-medium">{t('leads.name')}</label>
                <input
                  type="text"
                  className="mt-1 w-full border rounded px-3 py-2 text-sm"
                  placeholder={t('leads.enterName')}
                  value={newLeadList.leadListTitle}
                  onChange={(e) => setNewLeadList({ ...newLeadList, leadListTitle: e.target.value })}
                />
              </div>
              <div>
                <label className="block text-sm font-medium">{t('leads.maxQuantity')}</label>
                <input
                  type="number"
                  className="mt-1 w-full border rounded px-3 py-2 text-sm"
                  value={newLeadList.maxQuantity}
                  onChange={(e) => setNewLeadList({ ...newLeadList, maxQuantity: parseInt(e.target.value || '0', 10) })}
                />
              </div>
            </div>

            {/* Mode toggle */}
            <div className="mt-4 flex gap-2">
              <button
                type="button"
                onClick={() => setLiImportMode('builder')}
                className={`px-3 py-2 rounded-md text-sm border ${
                  liImportMode === 'builder'
                    ? 'bg-white border-blue-500 text-blue-700'
                    : 'bg-gray-50 border-gray-300 text-gray-700 hover:bg-white'
                }`}
              >
                Build search
              </button>
              <button
                type="button"
                onClick={() => setLiImportMode('url')}
                className={`px-3 py-2 rounded-md text-sm border ${
                  liImportMode === 'url'
                    ? 'bg-white border-blue-500 text-blue-700'
                    : 'bg-gray-50 border-gray-300 text-gray-700 hover:bg-white'
                }`}
              >
                Paste full URL
              </button>
            </div>

            {/* Builder */}
            {liImportMode === 'builder' && (
              <div className="mt-4 space-y-3">
                <div>
                  <label className="block text-sm font-medium">
                    Keywords <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className="mt-1 w-full border rounded px-3 py-2 text-sm"
                    placeholder="e.g. web developer, react, node.js"
                    value={liKeywords}
                    onChange={(e) => setLiKeywords(e.target.value)}
                  />
                  <p className="text-xs text-gray-600 mt-1">
                    We’ll start from the LinkedIn people search page and apply filters in the UI.
                  </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-sm font-medium">
                      Location <span className="text-gray-400 font-normal">(optional)</span>
                    </label>
                    <input
                      type="text"
                      className="mt-1 w-full border rounded px-3 py-2 text-sm"
                      placeholder="e.g. Netherlands, Amsterdam Area"
                      value={liLocation}
                      onChange={(e) => setLiLocation(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium">
                      Current companies <span className="text-gray-400 font-normal">(optional)</span>
                    </label>
                    <input
                      type="text"
                      className="mt-1 w-full border rounded px-3 py-2 text-sm"
                      placeholder="e.g. Booking.com, ASML"
                      value={liCompanies}
                      onChange={(e) => setLiCompanies(e.target.value)}
                    />
                    <p className="text-xs text-gray-500 mt-1">Comma-separated.</p>
                  </div>
                </div>

                {/* URL preview */}
                <div className="bg-white border rounded-md p-3">
                  <div className="text-xs text-gray-500 mb-1">Search URL preview</div>
                  <div className="text-xs font-mono break-all text-gray-800">{liPreviewUrl}</div>
                </div>
              </div>
            )}

            {/* URL paste */}
            {liImportMode === 'url' && (
              <div className="mt-4 space-y-2">
                <label className="block text-sm font-medium">{t('leads.linkedinSearchUrl')}</label>
                <input
                  type="text"
                  className="mt-1 w-full border rounded px-3 py-2 text-sm"
                  placeholder="https://www.linkedin.com/search/results/people/?keywords=..."
                  value={newLeadList.linkedinSearchUrl}
                  onChange={(e) => setNewLeadList({ ...newLeadList, linkedinSearchUrl: e.target.value })}
                />
                <p className="text-xs text-gray-600">
                  Tip: set filters in LinkedIn first, then copy/paste the URL here.
                </p>
              </div>
            )}

            {errorMessage && (
              <div className="text-red-600 text-sm mt-3">{errorMessage}</div>
            )}

            <div className="flex justify-end gap-2 mt-5">
              <button
                onClick={() => setShowNewLeadListModal(false)}
                className="bg-gray-200 text-gray-800 px-4 py-2 rounded-md text-sm"
                disabled={isLoading}
              >
                {t('leads.close')}
              </button>
              <button
                onClick={handleNewLeadListSubmit}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm"
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2" />
                ) : null}
                {t('leads.import')}
              </button>
            </div>
          </div>
        </div>
      )}



  
 




      {/* Modal for uploading a CSV file */}
      {showNewLeadListCsvModal && (
        <div className="fixed inset-0 bg-white/40 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="bg-gray-100 w-full max-w-md p-6 rounded-xl shadow-xl border">
            <h3 className="text-lg font-semibold">{t('leads.uploadCSV')}</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium">{t('leads.name')}</label>
                <input
                  type="text"
                  className="mt-1 w-full border rounded px-3 py-2 text-sm"
                  value={newLeadList.leadListTitle}
                  onChange={(e) => setNewLeadList({ ...newLeadList, leadListTitle: e.target.value })}
                />
              </div>
              <div>
                <label className="block text-sm font-medium">{t('leads.chooseFile')}</label>
                <input
                  type="file"
                  accept=".csv"
                  className="mt-1 w-full text-sm"
                  onChange={handleCsvUpload}
                />
              </div>
              <div>
                <label className="block text-sm font-medium">{t('leads.maxQuantity')}</label>
                <input
                  type="number"
                  className="mt-1 w-full border rounded px-3 py-2 text-sm"
                  value={newLeadList.maxQuantity}
                  onChange={(e) =>
                    setNewLeadList({ ...newLeadList, maxQuantity: parseInt(e.target.value) })
                  }
                />
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={() => setShowNewLeadListCsvModal(false)}
                className="bg-gray-200 text-gray-800 px-4 py-2 rounded-md text-sm"
              >
                {t('leads.close')}
              </button>
              <button
                onClick={handleNewLeadListSubmitCsv}
                className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm"
              >
                {t('leads.upload')}
              </button>
            </div>
          </div>
        </div>
      )}




      {showNewLeadListSalesNavModal && (
      <div className="fixed inset-0 bg-white/40 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="bg-gray-100 w-full max-w-md p-6 rounded-xl shadow-xl border">
          <h3 className="text-lg font-semibold">{t('leads.importFromSalesNavigator')}</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium">{t('leads.name')}</label>
              <input
                type="text"
                className="mt-1 w-full border rounded px-3 py-2 text-sm"
                value={newLeadList.leadListTitle}
                onChange={(e) => setNewLeadList({ ...newLeadList, leadListTitle: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-sm font-medium">{t('leads.salesNavigatorUrl')}</label>
              <input
                type="text"
                className="mt-1 w-full border rounded px-3 py-2 text-sm"
                value={newLeadList.linkedinSearchUrl}
                onChange={(e) => setNewLeadList({ ...newLeadList, linkedinSearchUrl: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-sm font-medium">{t('leads.maxQuantity')}</label>
              <input
                type="number"
                className="mt-1 w-full border rounded px-3 py-2 text-sm"
                value={newLeadList.maxQuantity}
                onChange={(e) => setNewLeadList({ ...newLeadList, maxQuantity: parseInt(e.target.value) })}
              />
            </div>
            {errorMessage && (
              <div className="text-red-600 text-sm mt-2">{errorMessage}</div>
            )}
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button
              onClick={() => setShowNewLeadListSalesNavModal(false)}
              className="bg-gray-200 text-gray-800 px-4 py-2 rounded-md text-sm"
              disabled={isLoading}
            >
              {t('leads.close')}
            </button>
            <button
              onClick={handleNewLeadListSubmitSalesNav}
              className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm"
              disabled={isLoading}
            >
              {isLoading ? <span className="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2" /> : null}
              {t('leads.import')}
            </button>
          </div>
        </div>
      </div>
    )}




  </div>
  );
  
}

export default Leads;
